import React from "react";
import "./About.css";
import abtImg from "../../images/abt.png";
import abtBg from "../../images/abt-back.png";
import { theamContex } from "../../Context";
import { useContext } from "react";

function About() {
  const theme = useContext(theamContex);
  const darkMode = theme.state.darkMode;
  return (
    <div
      id="About"
      className="about"
      style={{
        background: darkMode ? "black" : "",
        color: darkMode ? "white" : "",
      }}
    >
      <div className="about-left">
        <img id="abt-bg" src={abtBg} alt="" />
        <img id="abt-hero" src={abtImg} alt="" />
      </div>
      <div className="about-right">
        <h1>About Me</h1>
        <h3>My name is Dipak Krishna Patil</h3>
        <p>
          Looking for a challenging role in a reputable organization to utilize
          my <br />
          technical skill and knowledge to learn about new technologies and
          emerging <br /> trends in the IT sector.
        </p>
        <a href="Resume-Dipak.pdf" download={"Resume-Dipak.pdf"}>
          <button className="button">Download Resume</button>
        </a>
      </div>
    </div>
  );
}

export default About;
